export enum IntervalType {
  days = 'days',
  weeks = 'weeks',
  months = 'months',
  trimesters = 'trimesters',
  semesters = 'semesters',
  years  = 'years',
  lifelong = 'lifelong',
}

const IntervalTypeValue = {
  [IntervalType.days]: 0,
  [IntervalType.weeks]: 1,
  [IntervalType.months]: 2,
  [IntervalType.trimesters]: 3,
  [IntervalType.semesters]: 4,
  [IntervalType.years]: 5,
  [IntervalType.lifelong]: 6,
};

export function getBiggerIntervalType(intervals: Array<IntervalType>): IntervalType {
  return intervals.length ? intervals.reduce((acc, act) => {
    if(!acc) return act;
    return IntervalTypeValue[acc] < IntervalTypeValue[act] ? act : acc;
  }) : IntervalType.lifelong;
}